"use client";

/**
 * NewForm DS hover icon — a thumbs-up for positive feedback.
 * On hover the whole hand cocks back and lifts, as if giving the gesture.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function ThumbsUpIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-thumbup" style={{ transformOrigin: "30% 90%" }}>
        <path d="M7 10.4v11.2" />
        <path d="M14.9 5.9 14 10h5.6a2 2 0 0 1 1.9 2.6l-2.3 7.6a2 2 0 0 1-1.9 1.4H4a1.8 1.8 0 0 1-1.8-1.8v-7.6A1.8 1.8 0 0 1 4 10.4h2.7a2 2 0 0 0 1.8-1.1L11.9 2.4a3 3 0 0 1 3 3.5Z" />
      </g>
    </HoverIconSvg>
  );
}
